import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { Tag } from '../../Tags';
import { TagsBlock, TagLink } from './partials';
export var Tags = function Tags(_ref) {
  var tags = _ref.tags;
  return React.createElement(TagsBlock, null, tags.map(function (tag, index) {
    var hasMainCategory = (tag.categories || []).find(function (category) {
      return category.type === 'main';
    });
    return React.createElement(Tag, {
      key: index,
      small: true
    }, React.createElement(TagLink, {
      href: hasMainCategory ? "/fondos-inversion/categorias/".concat(hasMainCategory.id, "-").concat(hasMainCategory.alias) : "/invertir/".concat(tag.alias)
    }, tag.name));
  }));
};